module.exports = __webpack_public_path__ + "images/autorent_small83f27f3a03d8c7acae8af887dbbdc2d2.png";